<template>
    <div>
        <gofix-card title="Line Items" fullContent classContent="mb-0">
            <gofix-default-table 
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openLineItemModal"
                @load-items="getTableData"
                @delete-items="deleteItems"
                @row-click="openEditItem"
                ref="gofixTable">
                <template slot="gofix_table:after-btn-create" v-if="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'create')">
                    <li class="control-item add-star-rate">
                        <a v-if="showSubtractBtn" @click="openLineItemModal('star-rate')" class="control-item-link cursor-pointer" title="Add Star Rate Item" v-b-tooltip.hover>
                            <img src="img/subtract.png" alt="Add Star Rate Item" class="h-20">
                        </a>
                    </li>
                </template>
                <template slot="gofix_table:before-control-right" v-if="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'update') && allowAddDeliveryOrder()">
                    <div class="tableSendSelected mr-4">
                        <gofix-button label="Record Delivery" @click="openDoLog" outline></gofix-button>
                    </div>
                </template>
                <template slot="gofix_table:item_description" slot-scope="row">
                    <span v-if="row.item && row.item.item_description_one && row.item.item_description_two">{{ row.item.item_description_one + " - "}}<span class="color-red">{{row.item.item_description_two}}</span></span>
                    <span v-else>{{ row.item.item_description_one ? row.item.item_description_one : row.item && row.item.item_description_two ? row.item.item_description_two : '' }}</span>
                </template>
                <template slot="gofix_table:total" slot-scope="row">
                    {{ $accounting.formatMoney(row.item.quantity * row.item.unit_price, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) }}
                </template>
                <template slot="gofix_table:net_amount" slot-scope="row">
                    {{ row.item.net_amount ? $accounting.formatMoney(row.item.net_amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                </template>
                <template slot="gofix_table:billable_amount" slot-scope="row">
                    {{$accounting.formatMoney(row.item.billable_amount)}}
                </template>
                <template slot="gofix_table:unit_price" slot-scope="row">
                    {{$accounting.formatMoney(row.item.unit_price)}}
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row">
                    <td class="text-nowrap order-line-item-total" :key="i" v-for="(field, i) in row.data.fields">
                        <div class="total-header text-right" v-if="field.key === 'quantity'">
                            <p>Total</p>
                        </div>

                        <div class="total-value d-flex align-items-end flex-column" v-if="field.key === 'net_amount'">
                            <p class="text-right">{{ Item.total_net_amount ? $accounting.formatMoney(Item.total_net_amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "&#45;&#45;" } }) : $accounting.formatMoney(0, { format: { pos : "%s %v", neg : "%s (%v)", zero: "&#45;&#45;" } }) }}</p>
                        </div>

                        <div class="total-value d-flex align-items-end flex-column" v-if="field.key === 'billable_amount'">
                            <p class="text-right">{{ Item.billable_net_amount ? $accounting.formatMoney(Item.billable_net_amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "&#45;&#45;" } }) : $accounting.formatMoney(0, { format: { pos : "%s %v", neg : "%s (%v)", zero: "&#45;&#45;" } }) }}</p>
                        </div>
                    </td>
                </template>
                <template slot="gofix_table:jobs" slot-scope="row">

                    {{ row.item.maintenance_program_id ? row.item.jobs_completed_count + " / " + row.item.jobs_all_count : '--'}}
                </template>
            </gofix-default-table>
        </gofix-card>
        <!--SOR Line Item Modal-->
        <b-modal :no-close-on-backdrop="true"
                 size="xl" id="modal-lineItem"
                 modal-class="modal-order-line-item"
                 :title="modals.sorItem.title"
                 hide-footer :centered="true"
                 v-model="modals.sorItem.open">
            <b-form class="formV2" v-bind:class="{'run-loading':modals.sorItem.loading}">
                <b-row class="content align-items-center">
                    <b-col md="3">
                        <div>
                            <label>Service Category</label>
                            <div class="info-right">{{ Item.service_category_name ? Item.service_category_name : '--' }}</div>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-properties
                                label="Location"
                                :contract-id="Item ? Item.contract_id : null"
                                :property-id="Item ? Item.service_location : null"
                                valueFormat="object"
                                v-model="lineItem.property" required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                class="fakeTable"
                                label="Item"
                                vLabel="sor_code"
                                :filterable="false"
                                @search="searchSOR"
                                @change="selectSORItem"
                                v-model="lineItem.sor"
                                :options="modals.sorItem.sorItems.data">

                            <template #gofixInput:dropdown:list-header>
                                <div class="d-table fakeTableHeader">
                                    <div class="d-table-cell cell itemTitle itemCode">Code</div>
                                    <div class="d-table-cell cell itemTitle itemSorGroup">SOR Group</div>
                                    <div class="d-table-cell cell itemTitle itemDescription">Description</div>
                                    <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Unit Price</div>
                                    <div class="d-table-cell cell itemTitle itemUom">UOM</div>
                                </div>
                            </template>
                            <template #gofixInput:dropdown:option="{ sor_code , description_one, description_two, sor_group, unit_of_measurement, unit_price, vendor_linking_sor}">
                                <div class="d-table fakeTableBody">
                                    <div class="d-table-cell cell itemValue itemCode">{{sor_code}}</div>
                                    <div class="d-table-cell cell itemValue itemSorGroup">{{sor_group ? sor_group.description_one : null}}</div>
                                    <div class="d-table-cell cell itemValue itemDescription">
                                        {{description_one}} <span class="color-red" v-if="description_two"> - {{description_two}}</span>
                                    </div>
                                    <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{(isLMUProject && isNonChargeableOfLMUProject) ? unit_price : ((vendor_linking_sor && vendor_linking_sor.length)? vendor_linking_sor[0].unit_price : unit_price) | formatMoney}}</div>
                                    <div class="d-table-cell cell itemValue itemUom">{{unit_of_measurement}}</div>
                                </div>
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12" v-show="Item.work_type !== 'Preventive'">
                        <hr>
                        <div>
                            <label>SOR group</label>
                            <div class="info-right display-table">
                                <span>{{lineItem.sor_group}}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12" v-if="Item.work_type !== 'Preventive'">
                        <div>
                            <label>Description</label>
                            <div class="info-right display-table">
                                <span>{{lineItem.item_description_one}}</span>
                                {{lineItem.item_description_two ? "-" : null}}
                                <span class="color-red">{{lineItem.item_description_two}}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12" v-if="Item.work_type === 'Preventive'">
                        <b-form-group label="Description" class="h-100 notFloat">
                            <b-form-textarea type="text" rows="4" max-rows="4" placeholder="" v-model="lineItem.item_description_one"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" v-if="Item.work_type !== 'Preventive'">
                        <div class="">
                            <label>Unit Rate</label>
                            <div class="info-right m-0">{{ lineItem.unit_price ? lineItem.unit_price : '' | formatMoney }}</div>
                        </div>
                    </b-col>
                    <b-col md="2" v-if="Item.work_type === 'Preventive'">
                        <gofix-form-input-number :disabled="true" label="Unit Rate" v-model="lineItem.unit_price" prefix="$"></gofix-form-input-number>
                    </b-col>
                    <b-col md="2" v-if="Item.work_type !== 'Preventive'">
                        <div class="">
                            <label>UOM</label>
                            <div class="info-right m-0">{{ lineItem.unit_of_measurement ? lineItem.unit_of_measurement : '--' }}</div>
                        </div>
                    </b-col>
                    <b-col md="2" v-if="Item.work_type === 'Preventive'">
                        <gofix-form-input :disabled="true" label="UOM" v-model="lineItem.unit_of_measurement"></gofix-form-input>
                    </b-col>
                    <b-col md="2">
                        <gofix-form-input-number
                                label="Quantity"
                                :include-thousands-separator="false"
                                :disabled="this.disabledQuantity"
                                v-model="lineItem.quantity">
                        </gofix-form-input-number>
                    </b-col>
                    <!--<b-col md="2" class="">
                        <div class="">
                            <label>FM Code</label>
                            <div class="info-right m-0">{{lineItem.fm_code || "--"}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" class="">
                        <div class="">
                            <label>GL Code</label>
                            <div class="info-right m-0">{{lineItem.gl_code || "--"}}</div>
                        </div>
                    </b-col>-->
                </b-row>
                <b-row v-if="Item.work_type !== 'Preventive'">
                    <b-col md="6">
                        <gofix-form-input-textarea 
                            :rows="4" 
                            :max-rows="4"
                            label="Remarks"
                            v-model="lineItem.remarks">
                        </gofix-form-input-textarea>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4" v-if="((Item.order_status !== 'Invoiced' || (Item.order_status === 'Invoiced' && lineItem.id === null) ) && Item.order_status !== 'Under Approval') || (Item.order_status === 'Pending Revision' && (Item.current_approval_level === -1 || Item.current_approval_level === null))">
                <gofix-button label="SUBMIT" @click="checkAmountWithBalanceBudget(1)" noBorder></gofix-button>
                <!-- <gofix-button label="SUBMIT" @click="saveSORitem" noBorder></gofix-button> -->
            </b-button-group>
        </b-modal>
        <!--Star Rate Modal-->
        <b-modal :no-close-on-backdrop="true"
                 size="xl"
                 id="modal-lineItem"
                 modal-class="modal-order-line-item"
                 :title="modals.starRate.title" hide-footer :centered="true" v-model="modals.starRate.open">
            <b-form class="formV2" v-bind:class="{'run-loading':modals.starRate.loading}">
                <b-row class="content align-items-center">
                    <b-col md="3">
                        <div>
                            <label>Service Category</label>
                            <div class="info-right">{{ Item.service_category_name ? Item.service_category_name : '--' }}</div>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-properties
                                label="Location"
                                :contract-id="Item ? Item.contract_id : null"
                                :property-id="Item ? Item.service_location : null"
                                valueFormat="object"
                                v-model="lineItem.property" required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Description" class="h-100">
                            <b-form-textarea type="text" rows="4" max-rows="4" placeholder="" v-model="lineItem.item_description_one"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <gofix-form-input-number :disabled="isLMUProject && isNonChargeableOfLMUProject" label="Unit Rate" v-model="lineItem.unit_price" prefix="$"></gofix-form-input-number>
                    </b-col>
                    <b-col md="2">
                        <gofix-form-input label="UOM" v-model="lineItem.unit_of_measurement"></gofix-form-input>
                    </b-col>
                    <b-col md="2">
                        <gofix-form-input-number label="Quantity" v-model="lineItem.quantity" :include-thousands-separator="false"></gofix-form-input-number>
                    </b-col>
                    <b-col md="2" class="">
                        <div class="">
                            <label>FM Code</label>
                            <div class="info-right m-0">{{lineItem.fm_code || "--"}}</div>
                        </div>
                    </b-col>
                    <b-col md="2" class="">
                        <div class="">
                            <label>GL Code</label>
                            <div class="info-right m-0">{{lineItem.gl_code || "--"}}</div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-textarea 
                            :rows="4" 
                            :max-rows="4"
                            label="Remarks"
                            v-model="lineItem.remarks">
                        </gofix-form-input-textarea>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4" v-if="((Item.order_status !== 'Invoiced' || (Item.order_status === 'Invoiced' && lineItem.id === null) ) && Item.order_status !== 'Under Approval') || (Item.order_status === 'Pending Revision' && (Item.current_approval_level === -1 || Item.current_approval_level === null))">
                <gofix-button label="SUBMIT" @click="checkAmountWithBalanceBudget(2)" noBorder></gofix-button>
                <!-- <gofix-button label="SUBMIT" @click="saveStarRate" noBorder></gofix-button> -->
            </b-button-group>
        </b-modal>
        <!--DO log-->
        <do-log ref="doLogModal" @reloadorder="reloadData"></do-log>
        <!--  -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.checkBalance.open">
            <div class="center px-3 pb-4">
                <p>Your WO amount <strong>({{ modals.checkBalance.data.net_amount | formatMoney }})</strong> is higher than the budget balance <br><strong>({{ modals.checkBalance.data.balance | formatMoney }})</strong></p>
                <span>Do you want to proceed?</span>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="saveLineItem">Yes</b-button>
                <b-button class="custom-btn" @click="modals.checkBalance.open = false">No</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    const doLog = () => import("./../modal-DO-log")

    export default {
        name: 'requestorInfo',
        components: {
            "do-log":doLog
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['order_line_item']));
            return {
                tableConfig:{
                    name: 'work-order-line-items',
                    controls:{
                        createTooptip: "Add maintenance item",
                        delete: !this.IsReadOnly && this.$checkRole(this.$accessModule.order_tabs.main_info, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "line_number",
                    sortDirection: "asc",
                },
                tableItems: [],
                disabledQuantity: false,
                modals:{
                    starRate:{
                        open:false,
                        loading:false,
                        title:"Add Star Rate Item",
                        properties:[]
                    },
                    sorItem:{
                        open:false,
                        loading:false,
                        title:"Add maintenance item",
                        properties:[],
                        sorItems:{
                            data: [],
                            timer: null
                        },
                    },
                    checkBalance: {
                        open: false,
                        type: 1, // 1: sorItem, 2: starRate
                        data: {
                            balance: 0,
                            net_amount: 0,
                        }
                    },
                },
                properties:[],
                is_show_submit_button:false,
                lineItem:{
                    id: null,
                    order_id: this.$route.params.id,
                    property: null,
                    property_id: null,
                    building_path: null,
                    item_description_one: null,
                    item_description_two: null,
                    unit_price: null,
                    unit_of_measurement: null,
                    quantity: null,
                    fm_code: null,
                    gl_code: null,
                    qty_delivered: null,
                    sor_group: null,
                    sor: null,
                    sor_code: null,
                    sor_item_id: 0,
                    line_status: "Pending",
                    remarks: null,
                },
                showSubtractBtn: true,
                showButtonSubmit: true,
                cancelToken: null,
            }
        },
        watch: {
            "lineItem.property" : function(val){
                if(val){
                    this.loadFMGLcode(val.id);
                    this.lineItem.property_id = val.id;
                    this.lineItem.building_path = val.root_path ? val.root_path : null;
                }else{
                    this.lineItem.property_id = null;
                    this.lineItem.building_path = null;
                    this.lineItem.fm_code = null;
                    this.lineItem.gl_code= null;
                }
            },
            "Item.order_type" : function(val, old){
                this.updateTooptip(val)
            },
            "Item.order_status" : function(val){
                this.updateDeleted(val);
                this.updateAdd(val);
            },
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                UserLogin: 'AuthController/user',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
            isLMUProject() {
                if(!this.Item || !this.Item.supplier_contract) return false;
                return true;
            },
            isNonChargeableOfLMUProject() {
                if(!this.Item || !this.Item.supplier_contract || !this.Item.supplier_contract.lmu_settings || !this.Item.supplier_contract.lmu_settings.is_non_chargeable) return false;
                return true;
            },
            lineItemLimit() {
                if(!this.Item || !this.Item.supplier_contract || !this.Item.supplier_contract.lmu_settings || !this.Item.supplier_contract.lmu_settings.chargeable_non_approval_line_item_limit) return 0;
                return this.Item.supplier_contract.lmu_settings.chargeable_non_approval_line_item_limit;
            }
        },
        created() {
            this.updateTooptip(this.Item.order_type)
            this.updateDeleted(this.Item.order_status)
            this.updateAdd(this.Item.order_status);
        },
        methods: {
            allowAddDeliveryOrder(){
                let order_status = ["Closed","Cancelled", "Rejected"];
                if(this.Item && 
                    this.Item.order_status && 
                    order_status.includes(this.Item.order_status)){
                    return false;
                }
                
                if(this.UserLogin && this.UserLogin.organization && this.UserLogin.organization.is_supplier) {
                    let isAllow = false;
                    if(this.$checkRole(this.$accessModule.allow_supplier_to_add_delivery_order, 'allow_supplier_to_add_delivery_order')) isAllow = true
                    this.tableConfig.controls.create = isAllow;
                    return isAllow;
                }
                if(this.Item && 
                this.Item.client_contract && 
                this.Item.client_contract.settings && 
                this.Item.client_contract.settings.allows_adding_delivery_orders_with_order_status &&
                this.Item.client_contract.settings.allows_adding_delivery_orders_with_order_status.length
                ){
                    if(this.Item.client_contract.settings.allows_adding_delivery_orders_with_order_status.includes(this.Item.order_status)){
                        return true;
                    }
                    return false;
                }
                return true;
            },
            async updateDeleted (val){
                if(this.IsReadOnly) {
                    this.tableConfig.controls.delete = false
                    this.$nextTick(() => {
                        if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateCreateBT()
                    });
                    return
                }
                //|| val === 'Completed'
                if(val === 'Invoiced' || val === 'Under Approval' || (this.Item.order_status === 'Pending Revision' && this.Item.current_approval_level > -1)) {
                    this.tableConfig.controls.delete = false
                } else {
                    if((this.Item.order_status === 'Completed' || this.Item.order_status === 'Partially Completed') && 
                        (!this.Item.client_contract.settings || 
                        (this.Item.client_contract.settings &&
                        !this.Item.client_contract.settings.is_allow_change_sor_rwo_completed)
                    )){
                        this.tableConfig.controls.delete = false
                    }else{
                        this.tableConfig.controls.delete = this.$checkRole(this.$accessModule.order_tabs.main_info, 'delete');
                    }
                }
                this.$nextTick(() => {
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateDeletedBT()
                });
            },
            async updateAdd (val) {
                if(this.IsReadOnly) {
                    this.showSubtractBtn = false;
                    this.tableConfig.controls.create = false;
                    this.$nextTick(() => {
                        if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateCreateBT()
                    });
                    return
                }
                if(val === 'Under Approval' || (this.Item.order_status === 'Pending Revision' && this.Item.current_approval_level > -1)) {
                    this.showSubtractBtn = false;
                    this.tableConfig.controls.create = false;
                }
                else {
                    this.showSubtractBtn = true;
                    this.tableConfig.controls.create = this.$checkRole(this.$accessModule.order_tabs.main_info, 'create');
                }
                this.$nextTick(() => {
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateCreateBT()
                });
            },
            async updateTooptip (val){
                if(val === 'PWO') {
                    this.tableConfig.controls.createTooptip = "Add Maintenance Item"
                } else {
                    this.tableConfig.controls.createTooptip = "Add SOR Item"
                }
            },
            /*-- Save data -----------------------------------*/
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.tableConfig.filter.order_id.value = this.$route.params.id
                await this.$store.dispatch('OrderItemController/deleteItems', {ids: ids, order_id: this.$route.params.id })
                    .then(response => {
                        this.$emit('reload-order');
                        resolve(this.$notificationV2('deleting', 'line_item'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            async createData(data){
                this.$store.dispatch("OrderItemController/createOrderItem",data)
                    .then(reponse => {
                        this.$alertNotification(this.$notificationV2('adding', 'line_item'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$emit('reload-order');
                    })
                    .catch(err => {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    })
            },
            async updateData(data){
                this.$store.dispatch("OrderItemController/updateOrderItem",{id:data.id,data:data})
                    .then(reponse => {
                        this.$alertNotification(this.$notificationV2('editing', 'line_item'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$emit('reload-order');
                    })
                    .catch(err => {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    })
            },
            async saveStarRate(){
                // if(!this.lineItem.property){
                //     return this.$alertNotification("Please select a property", "danger");
                // }
                // if(!this.lineItem.quantity){
                //     return this.$alertNotification("Please enter quantity", "danger");
                // }
                // if(this.Item.client_contract.settings.is_required_fm_code && !this.lineItem.fm_code) {
                //     return this.$alertNotification("FM Code is a required field.", "danger");
                // }
                // if(this.Item.client_contract.settings.is_required_gl_code && !this.lineItem.gl_code) {
                //     return this.$alertNotification("GL Code is a required field.", "danger");
                // }
                this.modals.starRate.loading = true;
                let data = Object.assign({},this.lineItem);
                data.unit_price = this.$accounting.unformat(data.unit_price);
                if(data.id){
                    await this.updateData(data);
                }else{
                    await this.createData(data);
                }
                this.modals.starRate.loading = false;
                this.modals.starRate.open = false;
            },
            async saveSORitem(){
                // if(!this.lineItem.property){
                //     return this.$alertNotification("Please select a property", "danger");
                // }
                // if(!this.lineItem.quantity){
                //     return this.$alertNotification("Please enter quantity", "danger");
                // }
                // if(!this.lineItem.sor){
                //     return this.$alertNotification("Please select a SOR item", "danger");
                // }
                // if(this.Item.client_contract.settings.is_required_fm_code && !this.lineItem.fm_code) {
                //     return this.$alertNotification("FM Code is a required field.", "danger");
                // }
                // if(this.Item.client_contract.settings.is_required_gl_code && !this.lineItem.gl_code) {
                //     return this.$alertNotification("GL Code is a required field.", "danger");
                // }
                this.modals.sorItem.loading = true;
                let data = Object.assign({},this.lineItem);
                data.unit_price = this.$accounting.unformat(data.unit_price);
                if(data.id){
                    await this.updateData(data);
                }else{
                    await this.createData(data);
                }
                this.modals.sorItem.loading = false;
                this.modals.sorItem.open = false;
            },
            checkAmountWithBalanceBudget(type = 1) {
                this.modals.checkBalance.type = type;
                if(!this.lineItem.property){
                    return this.$alertNotification("Please select a property", "danger");
                }
                if(!this.lineItem.quantity){
                    return this.$alertNotification("Please enter quantity", "danger");
                }
                if(this.modals.checkBalance.type == 1 && !this.lineItem.sor){
                    return this.$alertNotification("Please select a SOR item", "danger");
                }
                if(this.Item.client_contract.settings && this.Item.client_contract.settings.is_required_fm_code && !this.lineItem.fm_code) {
                    return this.$alertNotification("FM Code is a required field.", "danger");
                }
                if(this.Item.client_contract.settings && this.Item.client_contract.settings.is_required_gl_code && !this.lineItem.gl_code) {
                    return this.$alertNotification("GL Code is a required field.", "danger");
                }

                if(type == 1) {
                    this.modals.sorItem.loading = true;
                } else {
                    this.modals.starRate.loading = true;
                }

                let data = Object.assign({},this.lineItem);
                data.unit_price = this.$accounting.unformat(data.unit_price);
                this.$store.dispatch("OrderItemController/checkAmountWithBalanceBudget",data)
                    .then(result => {
                        this.modals.sorItem.loading  = false;
                        this.modals.starRate.loading = false;
                        this.modals.starRate.open    = false;
                        this.modals.sorItem.open     = false;
                        if(result.is_check) {
                            this.modals.checkBalance.data = result;
                            this.modals.checkBalance.open = true;
                        } else {
                            this.saveLineItem();
                        }
                    })
                    .catch(err => {
                        this.modals.sorItem.loading  = false;
                        this.modals.starRate.loading = false;
                        console.log(err)
                    })
            },
            saveLineItem() {
                this.modals.checkBalance.open = false;
                if(this.modals.checkBalance.type == 1)
                  this.saveSORitem();
                else
                  this.saveStarRate();
            },

            /*-- Load data -----------------------------------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.order_id.value = this.$route.params.id;
                await this.$store.dispatch("OrderItemController/getOrderItem", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        let isNeedArrpoval = false;
                        if( this.Item.supplier_contract && 
                            this.Item.supplier_contract.hasOwnProperty('is_supplier_under_lmu_project') && 
                            this.Item.supplier_contract.is_supplier_under_lmu_project &&
                            (
                                this.Item.supplier_contract.lmu_settings && 
                                this.Item.supplier_contract.lmu_settings.hasOwnProperty('is_non_chargeable') && 
                                this.Item.supplier_contract.lmu_settings.hasOwnProperty('chargeable_non_approval_line_item_limit') && 
                                this.Item.supplier_contract.lmu_settings.is_non_chargeable == false &&
                                this.Item.supplier_contract.lmu_settings.chargeable_non_approval_line_item_limit
                            )
                            ) {
                            if(this.tableItems.length) {
                                const limit = this.Item.supplier_contract.lmu_settings.chargeable_non_approval_line_item_limit;
                                const filter = this.tableItems.filter(item => item.net_amount> limit);
                                if(filter.length) {
                                    isNeedArrpoval = true;
                                }
                            }
                        }
                        this.$emit('orderNeedApproval', isNeedArrpoval);
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            loadFMGLcode(property_id){
                this.$store.dispatch("FmCodeController/getActiveItem", {
                    property_id:property_id,
                    service_category_id:this.Item.service_category_id,
                    work_type:this.Item.work_type,
                    is_charge_customer:this.Item.is_charge_customer || false,
                })
                    .then(response => {
                        if(response){
                            this.setFMCode(response.fm_code,response.gl_code);
                        }else{
                            this.setFMCode(null,null);
                        }
                    })
                    .catch(err => {
                        this.setFMCode(null,null);
                    })
            },
            getListSOR(sftSor){
                if(this.modals.sorItem.sorItems.timer) {
                    clearTimeout(this.modals.sorItem.sorItems.timer);
                }
                let notInIds = [];
                for(let i = 0; i < this.Item.get_order_line_item.length; i++){
                    if(this.Item.get_order_line_item[i].line_status === "Invoiced"){
                        notInIds.push(this.Item.get_order_line_item[i].sor_item_id)
                    }
                }
                this.modals.sorItem.sorItems.timer =  setTimeout(() => {
                    this.$store.dispatch( 'v2SorController/searchSorCode',
                        [1, 100, '',
                            {
                                service_category_id: this.Item.service_category_id,
                                contract_term_id: this.Item.client_contract.contract_terms[0] ? this.Item.client_contract.contract_terms[0].id : null,
                                is_maintenance: this.Item.order_type === "PWO" ? true : false,
                                /*work_type: this.Item.order_type === "PWO" ? null : this.Item.work_type,*/
                                search: sftSor,
                                notInIds:notInIds
                            },
                            this.Item.client_contract ? this.Item.client_contract.id : null,
                            this.Item.supplier_id,
                            this.Item.id
                        ])
                        .then(response => {
                            this.modals.sorItem.sorItems.timer = false;
                            this.modals.sorItem.sorItems.data = response.data.data.items;
                        })
                        .catch(err => {
                            console.log(err)
                            this.modals.sorItem.sorItems.timer = false;
                        })
                },300)
            },
            searchSOR(search, loading){
                loading(true);
                if(this.modals.sorItem.sorItems.timer) {
                    clearTimeout(this.modals.sorItem.sorItems.timer);
                }
                let notInIds = [];
                for(let i = 0; i < this.Item.get_order_line_item.length; i++){
                    if(this.Item.get_order_line_item[i].line_status === "Invoiced"){
                        notInIds.push(this.Item.get_order_line_item[i].sor_item_id)
                    }
                }
                this.modals.sorItem.sorItems.timer =  setTimeout(() => {
                    if ( this.cancelToken ) {
                        this.cancelToken.cancel('cancelling');
                    }
                    this.abortController_ = new AbortController();
                    const CancelToken = global.axios.CancelToken;
                    this.cancelToken = CancelToken.source();
                    
                    this.modals.sorItem.sorItems.data = [];
                    this.$store.dispatch( 'v2SorController/searchSorCode',
                        [1, 100, '',
                            {
                                service_category_id: this.Item.service_category_id,
                                contract_term_id: this.Item.client_contract.contract_terms[0] ? this.Item.client_contract.contract_terms[0].id : null,
                                is_maintenance: this.Item.order_type === "PWO" ? true : false,
                                /*work_type: this.Item.order_type === "PWO" ? null : this.Item.work_type,*/
                                search: search,
                                notInIds:notInIds
                            },
                            this.Item.client_contract ? this.Item.client_contract.id : null,
                            this.Item.supplier_id,
                            null,
                            null,
                            this.cancelToken.token,
                        ],)
                        .then(response => {
                            this.modals.sorItem.sorItems.timer = false;
                            this.modals.sorItem.sorItems.data = response.data.data.items;
                            loading(false)
                        })
                        .catch(err => {
                            console.log(err)
                            this.modals.sorItem.sorItems.timer = false;
                            loading(false)
                        })
                },300)
            },

            /*-- Attribute -----------------------------------*/
            openLineItemModal(type){
                //this.Item.order_status === 'Completed' this.Item.order_status === 'Partially Completed'
                if(this.Item.order_status === 'Invoiced' ||
                    this.Item.order_status === 'Cancelled' ||
                    this.Item.order_status === 'Rejected' ||
                    this.Item.order_status === 'Closed'
                    )
                    return;
                if(
                    (this.Item.order_status === 'Completed' || this.Item.order_status === 'Partially Completed') && 
                    (!this.Item.client_contract.settings || 
                    (this.Item.client_contract.settings && !this.Item.client_contract.settings.is_allow_change_sor_rwo_completed)
                    )){
                    return;
                }
                //thai
                this.disabledQuantity = false
                this.lineItem = Object.assign(this.lineItem,{
                    id: null,
                    order_id: this.$route.params.id,
                    property: null,
                    property_id: null,
                    building_path: null,
                    item_description_one: null,
                    item_description_two: null,
                    unit_price: this.isLMUProject && this.isNonChargeableOfLMUProject ? this.$accounting.formatMoney(0) : null,
                    unit_of_measurement: null,
                    quantity: null,
                    fm_code: null,
                    gl_code: null,
                    qty_delivered: null,
                    sor_group: null,
                    sor: null,
                    sor_code: null,
                    sor_item_id: 0,
                    line_status: "Pending",
                    remarks: null
                });
                if(type === "star-rate"){
                    this.modals.starRate.title = "Add Star Rate Item"
                    this.lineItem.property = this.Item.property;
                    this.modals.starRate.open = true;
                }else{
                    if(this.Item.order_type === 'PWO') {
                        this.modals.sorItem.title = "Add Maintenance Item"
                    } else {
                        this.modals.sorItem.title = "Add SOR Item"
                    }
                    this.lineItem.property = this.Item.property;
                    this.modals.sorItem.open = true;
                    this.getListSOR()
                }

                this.properties = [];
                this.loadFistProperty(this.Item.service_location)
            },
            openEditItem(item){
                if(this.IsReadOnly || !this.$checkRole(this.$accessModule.order_tabs.main_info, 'update')) return;
                if(this.Item.order_status === 'Invoiced' || this.Item.order_status === 'Under Approval' || (this.Item.order_status === 'Pending Revision' && this.Item.current_approval_level > -1)) return;
                
                if((this.Item.order_status === 'Completed' || this.Item.order_status === 'Partially Completed') && 
                    (!this.Item.client_contract.settings || 
                    (this.Item.client_contract.settings && !this.Item.client_contract.settings.is_allow_change_sor_rwo_completed)
                )){
                    return;
                }
                this.lineItem = Object.assign(this.lineItem,{
                    id: item.id,
                    order_id: this.$route.params.id,
                    property: item.property,
                    property_id: item.property_id,
                    building_path: item.building_path,
                    item_description_one: item.item_description_one,
                    item_description_two: item.item_description_two,
                    unit_price: this.$accounting.formatMoney(item.unit_price),
                    unit_of_measurement: item.unit_of_measurement,
                    quantity: item.quantity.toString(),
                    fm_code: item.fm_code,
                    gl_code: item.gl_code,
                    qty_delivered: item.qty_delivered,
                    sor_group: item.sor && item.sor.sor_group ? item.sor.sor_group.description_one : null,
                    sor: item.sor,
                    sor_code: item.sor_code,
                    sor_item_id: item.sor_item_id,
                    line_status: item.line_status,
                    remarks: item.remarks
                });

                if(item.sor_item_id){
                    this.modals.sorItem.open = true;
                    if(this.Item.order_type === 'PWO') {
                        this.modals.sorItem.title = "Edit Maintenance Item"
                    } else {
                        this.modals.sorItem.title = "Edit SOR Item"
                    }
                }else{
                    this.modals.starRate.title = "Edit Star Rate Item"
                    this.modals.starRate.open = true;
                }
                this.properties = [];
                this.loadFistProperty(this.Item.service_location)
            },
            openDoLog(){
                this.$refs.doLogModal.openModal();
            },
            loadFistProperty(id){
                if(id) {
                    global.axios(`api/contracts/${this.Item.contract_id}/properties/${id}`, {
                        method: "GET",
                        data: {},
                        headers: {
                            Accept: "application/json",
                        }
                    })
                        .then(result => {
                            result.data.data.children = null;
                            this.properties.push(result.data.data);
                        })
                }

            },
            setFMCode(fm_code,gl_code){
                this.lineItem.fm_code = fm_code;
                this.lineItem.gl_code = gl_code;
            },
            selectSORItem(item){
                this.disabledQuantity = false
                if(!this.lineItem.id){
                    this.lineItem.quantity = item.quantity
                    /*for(let i = 0; i < this.tableItems.length; i++){
                        if(this.tableItems[i].sor_item_id === item.id){
                           this.disabledQuantity = true
                           this.lineItem.quantity = '0'
                        }
                    }*/
                }
                this.lineItem.item_description_one = item.description_one;
                this.lineItem.item_description_two = item.description_two;
                this.lineItem.unit_price = (this.isLMUProject && this.isNonChargeableOfLMUProject) ? this.$accounting.formatMoney(item.unit_price) : ((item.vendor_linking_sor && item.vendor_linking_sor.length) > 0 ? this.$accounting.formatMoney(item.vendor_linking_sor[0].unit_price) : this.$accounting.formatMoney(item.unit_price));

                this.lineItem.unit_of_measurement = item.unit_of_measurement;
                this.lineItem.sor_code = item.sor_code;
                this.lineItem.sor_item_id = item.id;
                this.lineItem.sor_group = item.sor_group ? item.sor_group.description_one : null;
            },
            reloadData(){
                this.$refs.gofixTable.reloadTableItems();
                this.$emit('reload-order');
            },
            reloadLineItemData(){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
    }
</script>
